import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";

export type ToastMessage = {
  duration?: number;
  message?: string;
  title?: string;
};

type ToastContext = {
  addToast: (toast: ToastMessage) => void;
  removeToast: (id: string) => void;
  toasts: ToastMessage[];
};

export const ToastContext = createContext<ToastContext>(createDefaultContext());
